<template>
  <div>
    <button @click="$router.back()">← Back</button>
    <h1 style="text-align:center">EMM AI Logs Dashboard</h1>
    <iframe
      src="/grafana/d/249b1c3e-f16c-4303-90aa-08b68c4d1fa9/openai-usage-overview?orgId=1&kiosk"
      width="100%"
      height="800"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'LogsDashboard'
}
</script>
